import { formatShortcutKey } from '@/data/posShortcuts';

type ShortcutBadgeVariant = 'default' | 'primary' | 'tileActive' | 'tileIdle';

interface ShortcutBadgeProps {
  binding: string;
  variant?: ShortcutBadgeVariant;
  className?: string;
}

const VARIANT_CLASS: Record<ShortcutBadgeVariant, string> = {
  default: 'border-gray-200 bg-gray-50 text-gray-600',
  primary: 'border-white/50 bg-white/25 text-white',
  tileActive: 'border-primary-200 bg-white text-primary-700',
  tileIdle: 'border-gray-200 bg-gray-50 text-gray-500',
};

/** Compact kbd pill for POS action buttons. */
export default function ShortcutBadge({
  binding,
  variant = 'default',
  className = '',
}: ShortcutBadgeProps) {
  const label = formatShortcutKey(binding);
  if (!label) return null;
  return (
    <kbd
      className={`inline-flex items-center px-1.5 py-0.5 rounded border text-[10px] font-mono font-semibold leading-none shrink-0 ${VARIANT_CLASS[variant]} ${className}`}
    >
      {label}
    </kbd>
  );
}
